export default __webpack_public_path__ + "static/media/47UM61_47UM62.72c50f00.png";